import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Accordion } from '@frontend/design-system';
import { useSchedulingLocationInfo } from '../../../../hooks';
import { quickfillManageListTrackingIds } from '../../tracking-ids';
import { RecipientTally } from '../components/recipient-tally';
import { useQuickFillRecipientShallowStore } from '../store';
import { QuickFillList } from './list';

export const ManageListTabContent = () => {
  const { isMultiLocation, selectedLocationIds } = useSchedulingLocationInfo();
  return isMultiLocation ? <MultiLocationLists /> : <QuickFillList locationId={selectedLocationIds[0]} />;
};

const MultiLocationLists = () => {
  const { getLocationName, selectedLocationIds } = useSchedulingLocationInfo();
  const { recipientCounts } = useQuickFillRecipientShallowStore('recipientCounts');

  return (
    <Accordion showBoxShadow chevronSize={16} size='large' variant='location' startingValue={selectedLocationIds[0]}>
      {selectedLocationIds.map((locationId: string) => {
        const { filteredCount, totalCount } = recipientCounts[locationId] || {};

        return (
          <Accordion.Item
            key={locationId}
            value={locationId}
            trackingId={quickfillManageListTrackingIds.accordionToggle}
          >
            <Accordion.Header>
              <Accordion.Header.Location title={getLocationName(locationId)} />
              <div css={tallyContainerStyle}>
                <RecipientTally
                  filteredCount={filteredCount}
                  totalCount={totalCount}
                  textColor={theme.colors.primary80}
                />
              </div>
            </Accordion.Header>
            <Accordion.Body css={{ padding: 0 }}>
              <QuickFillList locationId={locationId} hasMultipleLocations />
            </Accordion.Body>
          </Accordion.Item>
        );
      })}
    </Accordion>
  );
};

const tallyContainerStyle = css`
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;

  & > p {
    position: absolute;
    right: -${theme.spacing(2)}; // Adjusting for right side padding
  }
`;
